import { render, staticRenderFns } from "./UploadOldImage.vue?vue&type=template&id=2faa30c4&"
import script from "./UploadOldImage.vue?vue&type=script&lang=js&"
export * from "./UploadOldImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadOldImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faa30c4')) {
      api.createRecord('2faa30c4', component.options)
    } else {
      api.reload('2faa30c4', component.options)
    }
    module.hot.accept("./UploadOldImage.vue?vue&type=template&id=2faa30c4&", function () {
      api.rerender('2faa30c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadOldImage.vue"
export default component.exports